import { KeyValue } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppContext {
  public appInsightConnectionString: string | null = null;
  public apiGatewayUrl: string | null = null;
}
